import { useState } from 'react';
import '../styles/components/ValuesSection.css';

export default function ValuesSection() {
  const steps = [
    [
      'Saosećanje',
      'Puno bola i nesporazuma u svetu nastaje zato što nedostaje saosećanje.',
      'Kod mnogih ljudi, upravo odsustvo samosaosećanja stoji u osnovi njihovih problema sa samopouzdanjem, komunikacijom i bliskošću. Samosaosećanje nas uči da prepoznamo sopstvenu patnju, prihvatimo je kao deo ljudskog iskustva i pružimo sebi nežnost – čak i kad pogrešimo, padnemo ili se osećamo ranjivo.To nije samosažaljenje, već način da budemo uz sebe kada nam je najpotrebnije.'
    ],
    [
      'Jasnoća',
      'To znači razumeti šta osećamo, zašto reagujemo na određeni način i šta nam je zaista važno.',
      'U našem radu, jasnoća se razvija kroz usporavanje, introspektivni rad i bezbedan odnos sa psihologom, gde postaje moguće razlikovati unutrašnje glasove – one autentične od onih naučenih, kritičkih ili zbunjujućih. Jasnoća ne znači imati sve odgovore, već sposobnost da bolje slušamo sebe, donesemo svesnije odluke i kreiramo život u skladu sa sopstvenim vrednostima i istinom.'
    ],
    [
      'Različitost',
      'Nijedna osoba ne doživljava život na isti način.',
      'Naša iskustva, način na koji nas drugi vide i izazovi sa kojima se suočavamo duboko su oblikovani različitim aspektima našeg identiteta – uključujući naciju, pol, seksualnost, telesne sposobnosti, telesnu građu, ekonomsko poreklo, etničku i kulturnu pozadinu. U terapiji, važno je da razumemo kako svi ovi faktori utiču na način na koji pojedinac doživljava svet i šta sa sobom donosi u terapijski prostor. Zato se posvećujemo kontinuiranom učenju i edukaciji o temama koje se tiču inkluzije i raznolikosti. Naš cilj je da terapijski prostor bude zaista sigurno mesto – za sve, a ne samo za neke.'
    ],
    [
      'Učenje',
      'Verujemo da je učenje celoživotni proces.',
      'Kao psiholozi, važno je da se kontinuirano angažujemo u iskustvima učenja kako bismo ostali budni i odgovorni u našem svetu koji se stalno menja. Kompetentnost u našem radu posmatramo kao nešto što zahteva kontinuiranu obuku i izloženost novim idejama. Takođe se trudimo da iskustva učenja donesemo našoj zajednici u obliku blogova, vebinara i radionica.'
    ],
    [
      'Solidarnost',
      'Verujemo da podrška treba da bude dostupna onda kada je najpotrebnija.',
      'Svesni smo da nam život donosi i teška vremena kao i da će se verovatno svako od nas u nekom periodu života susresti sa ozbiljnim finansijskim problemima. Upravo tada mentalno zdravlje može biti najugroženije. Zato smo u Clarity centru uveli kriznu skalu – model koji omogućava umanjenje cene usluga do 30%, u zavisnosti od situacije. Pored saradnje Centra sa volonterskim udruženjima, želimo da i našim klijentima pružimo podršku u trenucima kada im je najpotrebnija.'
    ],
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleTooltip = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="values">
      <div className="container">
        <h2>Vrednosti</h2>
        <p>
          U Psihološkom Centru Clarity verujemo da svaka osoba poseduje prirodnu sposobnost za isceljenje – kada se nađe u odnosu koji joj pruža sigurnost i poverenje.
        </p>
        <p>
          Kreiramo siguran i podržavajući terapijski prostor u kojem vam pomažemo da se povežete sa sobom i drugima – dublje, iskrenije i sa više jasnoće.
        </p>
        <div className="steps">
          {steps.map(([title, txt, more], index) => (
            <div
              key={index}
              className="step"
              onMouseEnter={() => toggleTooltip(index)}
              onMouseLeave={() => toggleTooltip(index)}
            >
              {activeIndex === index && (
                <div className="tooltip">
                  {more}
                </div>
              )}
              <h3>{title}</h3>
              <p>{txt}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
